import React, { Component } from 'react'
import YesNoResults from './YesNoResults'
import ScalingResults from './ScalingResults'
import OpenResults from './OpenResults'
import './styles.css'

class PollResults extends Component {
  render () {
    const { poll } = this.props
    const type = poll.pollType

    return (
      <div>
        {type === 'yes-no' && <YesNoResults votes={poll.votes} />}
        {type === 'scaling' && <ScalingResults votes={poll.votes} />}
        {type === 'open' && <OpenResults votes={poll.votes} />}
      </div>
    )
  }
}

export default PollResults



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/results/PollResults.js